import { Button, Icons, MarketingBanner } from '@cast/design-system';
import { Link } from 'components/router';

export const AIE_SERVERLESS_MODELS_BANNER_ID = 'serverless-models-notification';

export const AIEServerlessModelsBanner = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  return (
    <MarketingBanner
      title="New serverless inference in AI Enabler"
      testId="serverless-models-notification"
      message="Run Qwen3-Next-80B and Ministral-3-14B on our Serverless APIs. Start instantly with clear pricing and zero infrastructure to manage."
      onClose={onClose}
      action={
        <Button
          size="sm"
          endIcon={<Icons.ArrowRight />}
          component={Link}
          to="/llm/overview"
        >
          Try serverless inference
        </Button>
      }
    />
  );
};
